export const size = () => {
  let domEl: any = null;

  const setDomElement = (modalId: string) => {
    domEl = document.getElementById(modalId);
  };

  const isDesktop = () => {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];
    const isMobileAgent = toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
    if (isMobileAgent) return false;
    return window.innerWidth > 600;
  };

  const setSize = (size: any) => {
    const prefix = '--size_';
    size.width ? domEl.style.setProperty(prefix + 'width', size.width) : null;
    size.height
      ? domEl.style.setProperty(prefix + 'height', size.height)
      : null;
    size.maxWidth
      ? domEl.style.setProperty(prefix + 'max-width', size.maxWidth)
      : null;
    size.minWidth
      ? domEl.style.setProperty(prefix + 'min-width', size.minWidth)
      : null;
    size.maxHeight
      ? domEl.style.setProperty(prefix + 'max-height', size.maxHeight)
      : null;
    size.minHeight
      ? domEl.style.setProperty(prefix + 'min-height', size.minHeight)
      : null;
  };

  return {
    setDomElement,
    isDesktop,
    setSize,
  };
};



// WEBPACK FOOTER //
// ./src/uikit/components/AppModal/util/size.ts